import React, { useEffect, useState } from 'react';
import { useAuth } from "../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, reset } from "../slices/authSlice";
import { motion } from 'framer-motion';
import { useSound } from 'use-sound';
import { uploads } from "../utils/config";
import { Link } from 'react-router-dom';

// Importação das imagens
import bgMenuPreto from '../assets/images/bgMenu.png';
import homeImage from "../assets/images/home.png";
import coin from "../assets/images/coin.png";
import points from "../assets/images/points.png";
import tutorialImage from "../assets/images/tutorial.png";
import rankingImage from "../assets/images/ranking.png";
import challengeImage from "../assets/images/challenge.png";
import adminImage from "../assets/images/admin.png";
import loginImage from "../assets/images/login.png";
import exitImage from "../assets/images/exit.png";
import soundClick from "../assets/sounds/click.mp3";
import soundOver from "../assets/sounds/over.mp3";


function Navbar() {
  const { auth } = useAuth();
  const { user  } = useSelector((state) => state.user);
  const [loaded, setLoaded] = useState(false);
  const [clicked] = useSound(soundClick , { volume: 0.25 });
  const [over] = useSound(soundOver , { volume: 0.25 });
  const [menuOpen, setMenuOpen] = useState(false); // Estado do menu

  const profileImg = user ? user.profileImage : '';
  const typeUser = user ? user.type === "XHL" : false;

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1200); // Ajuste o tempo do delay se necessário
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(reset());
    navigate("/");
  };

  const navItemsLogged = [
    //{ name: "Como jogar", img: tutorialImage, linkto: "/HowPlay" },
    { name: "Ranking", img: rankingImage, linkto: "/Ranking" },
    { name: "Desafio", img: challengeImage, linkto: "/Progress" },
    { name: "Meu Perfil", img: profileImg, linkto: "/EditProfile" },
  ];

  const navItemsNotLogged = [
    //{ name: "Como jogar", img: tutorialImage, linkto: "/HowPlay" },
    { name: "Ranking", img: rankingImage, linkto: "/Ranking" },
    { name: "Login", img: loginImage, linkto: "/Login" },
  ];

  const navItemsAdmin = [
    { name: "Admin", img: adminImage, linkto: "/Admin" },
    //{ name: "Como jogar", img: tutorialImage, linkto: "/HowPlay" },
    { name: "Ranking", img: rankingImage, linkto: "/Ranking" },
    { name: "Desafio", img: challengeImage, linkto: "/Progress" },
    { name: "Meu Perfil", img: `${uploads}/users/${profileImg}`, linkto: "/EditProfile" },
  ];

  return (
    <nav className='fixed top-0 left-0 w-full z-50 mb-16 '>
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 ">
        <Link to="/">
        <motion.span
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.8 }}
          className="font-special font-extrabold text-2xl text-white"
          style={{
            color: "#fff",
            textAlign: "center",
            backgroundImage: `url(${bgMenuPreto})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          Challenge Game
        </motion.span>
        </Link>
        {(auth &&
        <div className="hidden md:flex items-center space-x-4">
          <Link to="BuyCoins">
            <div className="flex items-center bg-dour-suave/70 p-2 rounded-lg border border-gray-300 shadow-md  cursor-pointer">
              <img src={coin} alt="Moedas" className="w-6 h-6 mr-2" />
              <span className="text-white font-semibold">{user.coins || 0} moedas</span>
            </div>
          </Link>
          <div className="flex items-center bg-verde-oliva/70 p-2 rounded-lg border border-gray-300 shadow-md">
            <img src={points} alt="Pontuação" className="w-6 h-6 mr-2" />
            <span className="text-white font-semibold">{user.actualScore || 0} pontos</span>
          </div>
        </div>
        )}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white focus:outline-none"
          aria-label="Menu Toggle"
        >
          ☰
        </button>
        <div className={`${menuOpen ? "block" : "hidden"} w-full md:flex md:w-auto md:items-center`} id="navbar-default">
          <ul className="flex flex-col md:flex-row md:space-x-8">
            {(auth && !typeUser ? navItemsLogged : auth && typeUser ? navItemsAdmin : navItemsNotLogged).map(
              (item, index) => (
                <Link to={item.linkto} key={index}>
                  <motion.li
                    className="w-30 flex flex-col items-center text-center mt-4 md:mt-0 cursor-pointer"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1, duration: 0.8 }}
                    onMouseDown={clicked}
                    onMouseEnter={over}
                  >
                    <motion.img
                      src={item.img}
                      alt={item.name}
                      transition={{ delay: 0, duration: 0.3 }}
                      whileHover={{ delay: 0, scale: 1.05 }}
                      whileTap={{ scale: 0.95, delay: 0 }}
                      className="w-16 h-16 object-contain cursor-pointer rounded-full object-cover"
                    />
                    <motion.p
                      style={{
                        fontSize: "1rem",
                        fontWeight: "bold",
                        color: "#fff",
                        textAlign: "center",
                        backgroundImage: `url(${bgMenuPreto})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      {item.name}
                    </motion.p>
                  </motion.li>
                </Link>
              )
            )}
            {auth && (
              <motion.li
                className="w-30 flex flex-col items-center text-center mt-4 md:mt-0 cursor-pointer"
                onMouseDown={clicked}
                onMouseEnter={over}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 5 * 0.1, duration: 0.8 }}
                onClick={handleLogout}
              >
                <motion.img
                  src={exitImage}
                  alt="Sair"
                  className="w-16 h-16 object-contain rounded-full"
                  transition={{ delay: 0, duration: 0.3 }}
                  whileHover={{ delay: 0, scale: 1.05 }}
                  whileTap={{ scale: 0.95, delay: 0 }}
                />
                <p className="mt-2 text-sm">Sair</p>
              </motion.li>
            )}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
